// @material-ui/icons
//import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import HelpOutlinedIcon from '@material-ui/icons/HelpOutlined';
import SettingsIcon from '@material-ui/icons/Settings';
import Notifications from "@material-ui/icons/Notifications";
import Unarchive from "@material-ui/icons/Unarchive";
import GroupIcon from '@material-ui/icons/Group';
// core components/views for Admin layout
//import DashboardPage from "pages/Dashboard.js";
import Profile from "pages/Profile.js";
import Options from "pages/Options.js";
import Records from "pages/Records.js";
import GroupPage from "pages/GroupPage.js";
import New from "Ficha/New.js";
import Help from "pages/Help.js";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import NotificationsPage from "pages/Notifications.js";
import UpgradeToPro from "pages/UpgradeToPro.js";

// {
//   path: "/dashboard",
//   name: "Dashboard",
//   icon: Dashboard,
//   component: DashboardPage,
// },

const dashboardRoutes = [
  {
    path: "/new",
    name: "Nova APA",
    icon: AddCircleOutlineIcon,
    component: New,
  },
  {
    path: "/records",
    name: "Fichas Atendidas",
    icon: LibraryBooks,
    component: Records,
  },
  {
    path: "/options",
    name: "Opções",
    icon: SettingsIcon,
    component: Options,
  },
  {
    path: "/profile",
    name: "Perfil",
    icon: Person,
    component: Profile,
  },
  {
    path: "/group",
    name: "Grupo",
    icon: GroupIcon,
    component: GroupPage,
  },
  {
    path: "/notifications",
    name: "Notificações",
    icon: Notifications,
    component: NotificationsPage,
  },
  {
    path: "/help",
    name: "Central de Ajuda",
    icon: HelpOutlinedIcon,
    component: Help,
  },
  {
    path: "/upgrade",
    name: "Assinar PRO",
    icon: Unarchive,
    component: UpgradeToPro,
  }
];

export default dashboardRoutes;
